import React, { Component } from 'react'
import Tr from './../Tr'
import './../data-table.css'

class DataTableAdoptions extends Component {
  render () {
    return (
      <div className='container data-table data-table--adoption-list'>
        <table>
          <thead>
            <tr>
              <th>Disciplina</th>
              <th>Professor</th>
              <th>Livro</th>
              <th>Remover</th>
            </tr>
          </thead>
          <tbody>
            {this.props.list.length > 0
            ? this.props.list.map((adoption) => (
              <Tr
                onClickRemove={this.props.onClickRemove}
                toggleDialog={this.props.toggleDialog}
                handleOpenModal={this.props.handleOpenModal}
                changeItemDialog={this.props.changeItemDialog}
                role={this.props.role}
                key={adoption.id}
                item={adoption}
              />
              ))
            : <tr><td colSpan='6'>Não foram adicionados livros.</td></tr>
            }
          </tbody>
        </table>
      </div>
    )
  }
}

export default DataTableAdoptions



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableAdoptions/index.js